import type { ConfigProviderProps } from 'antd';
import { ConfigProvider } from 'antd';
import type { SizeType } from 'antd/es/config-provider/SizeContext';
import { useEffect, type PropsWithChildren } from 'react';
import type { LanguageType } from './locales';
import { Language, useLocale } from './locales';
import { Theme, useTheme, type ThemeType } from './themes';
import { ComponentSize } from './types/component-size';

interface ContipleAntdConfigProviderProps extends PropsWithChildren {
  theme?: ThemeType | ConfigProviderProps['theme'];
  language?: LanguageType;
  size?: SizeType;
  prefixCls?: string;
  props?: ConfigProviderProps;
}

export const ContipleAntdConfigProvider = ({
  children,
  theme = Theme.CONTIPLE,
  language = Language.KO,
  size = ComponentSize.MEDIUM,
  prefixCls = 'ctpl',
  props,
}: ContipleAntdConfigProviderProps) => {
  const themeProps = useTheme(theme);
  const localeProps = useLocale(language);

  useEffect(() => {
    const style = document.createElement('style');
    style.setAttribute('data-contiple', 'custom-css');
    style.textContent = `
      .${prefixCls}-input[readonly],
      .${prefixCls}-textarea[readonly] {
        background-color: #F4F4F5 !important;
      }
      .readonly .${prefixCls}-radio-label,
      .readonly .${prefixCls}-checkbox-label,
      .readonly .${prefixCls}-select-content {
        color: #09090B !important;
      }
      .${prefixCls}-select-suffix .anticon-down,
      .${prefixCls}-picker-suffix .anticon-calendar {
        color: #71717B !important;        
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {}, [theme]);

  return (
    <ConfigProvider
      prefixCls={prefixCls}
      {...themeProps}
      {...localeProps}
      componentSize={size}
      {...props}>
      {children}
    </ConfigProvider>
  );
};
